import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const DEFAULT_LANGUAGE = 'es-MX';

const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
  messages: {},
});

const loadedLocales = new Set();

async function loadLocale(locale) {
  if (loadedLocales.has(locale)) return;

  const response = await fetch(`/locales/${locale}.json`);
  if (!response.ok) {
    console.error(`[i18n] Failed to load locale: ${locale}`);
    return;
  }
  const messages = await response.json();
  i18n.setLocaleMessage(locale, messages);
  loadedLocales.add(locale);
}

async function loadAllLocales(localeCodes) {
  const codes = localeCodes || [DEFAULT_LANGUAGE];
  await Promise.all(codes.map((code) => loadLocale(code)));
}

export { loadLocale, loadAllLocales };
export default i18n;
